export const getPriceNodePerSKU = (title: string, price: number) => {
  if (!price) return null;
  return [
    title,
    <div key={`${title}/${price}`}>
      <strong>{`￦${price.toLocaleString()}`}</strong> / SKU
    </div>,
  ];
};

export const getImageStorageInfo = (imageStorage: number) => {
  const isCustom = imageStorage === -1;
  const value =
    imageStorage >= 1000 ? Math.floor(imageStorage / 1000) : imageStorage;
  const unit = imageStorage >= 1000 ? "GB" : "MB";

  return (
    <>
      {isCustom ? (
        "협의"
      ) : (
        <div className="title" key={`${value}${unit}`}>{`${value}${unit}`}</div>
      )}
    </>
  );
};

export const getImageStorageSummary = (imageStorage: number) => {
  if (imageStorage === -1) return null;
  const value =
    imageStorage >= 1000 ? Math.floor(imageStorage / 1000) : imageStorage;
  const unit = imageStorage >= 1000 ? "GB" : "MB";
  return `저장 공간 ${value}${unit}`;
};

export const getOtherColorSummary = (otherColor: boolean) => {
  return otherColor ? "다른 색상 생성 가능" : null;
};

export const getBackgroundSummary = (background: string, outfit: string) => {
  return `${background} & ${outfit}`;
};
